import * as React from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncUserPlanComponent} from '../components/AsyncComponent/AsyncComponent';
import {config} from "../config";

const ApiKeys: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('widgets.plan')}`}</title>
                <meta name="description" content="User Plan"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncUserPlanComponent}/>
            </Switch>
        </div>
    );
};

export default ApiKeys;
